import { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error('App crashed:', error, errorInfo);
  }

  handleReload = () => {
    try {
      // Clear potentially-stale auth state in case the crash was triggered by it
      localStorage.removeItem('adminToken');
      if ('caches' in window) {
        caches.keys().then((names) => names.forEach((n) => caches.delete(n)));
      }
    } catch (e) {}
    window.location.replace('/');
  };

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        data-testid="error-boundary"
        className="min-h-screen flex items-center justify-center px-6 bg-gradient-to-br from-[#d1223b] to-[#8a1627]"
      >
        <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl p-8 text-center">
          <div className="w-16 h-16 rounded-2xl bg-red-50 flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-[#d1223b]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01M5 19h14a2 2 0 001.84-2.75L13.74 4a2 2 0 00-3.48 0L3.16 16.25A2 2 0 005 19z" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-[#0F172A] mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Ha ocurrido un error
          </h1>
          <p className="text-[#64748B] mb-6 text-sm">
            La aplicación no pudo cargar correctamente. Esto suele resolverse recargando la página.
          </p>
          <div className="flex flex-col gap-2">
            <button
              onClick={this.handleRetry}
              data-testid="error-retry-btn"
              className="w-full bg-[#d1223b] text-white font-medium py-2.5 rounded-lg hover:bg-[#b51c31] transition-colors"
            >
              Recargar página
            </button>
            <button
              onClick={this.handleReload}
              data-testid="error-reset-btn"
              className="w-full text-[#64748B] text-sm py-2 hover:text-[#0F172A] transition-colors"
            >
              Limpiar caché y volver al inicio
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
